<template>
  <div role="document">
    <section id="info" class="container px-4 my-4">
      <div class="row">
        <div class="col-lg-12 px-lg-12 py-lg-12">
          <h1>Informazioni</h1>
          <p>
            Questo sito è stato realizzato nell'ambito di un progetto di ricerca del
            <a target="_blank" href="http://www.cirsfid.unibo.it">CIRSFID-Università di Bologna</a>,
            parzialmente finanziato dal
            <a target="_blank" href="https://cached.forges.forumpa.it/assets/Speeches/24096/06_co57_palmirani_monica.pdf">
              progetto della Presidenza del Consiglio denominato LexDatafication</a>.
            LexDatafication prevedeva la realizzazione di prototipi per dimostrare la fattibilità della conversione delle decisioni della Corte Costituzionale
            nel formato
            <a target="_blank" href="http://docs.oasis-open.org/legaldocml/akn-core/v1.0/akn-core-v1.0-part1-vocabulary.html">XML Akoma Ntoso</a>.
          </p>
          <p>
          Successivamente il
            <router-link
              to="/gruppo-di-lavoro">gruppo di lavoro</router-link>
              ha proseguito la ricerca raffinando i prototipi,
              aggiungendo funzionalità (e.g., NER) e implementando un'interfaccia grafica in linea con le linee guida
              <a target="_blank" href="https://designers.italia.it/guide/">AgID per lo sviluppo dei siti web delle pubbliche amministrazioni. </a>
          </p>
          <p>
            Il progetto è in continua evoluzione allo scopo di raffinare maggiormente l'accuratezza del markup XML-AKN della struttura dei documenti, dei riferimenti normativi, dei riferimenti giurisprudenziali, delle parti semantiche del discorso (e.g., motivazioni). Si intende utilizzare tecniche di legal analytics e di network analysis per agevolare la comprensione dei fenomeni giuridici a beneficio di tutti gli attori coinvolti (e.g., operatori del diritto, corte, cittadini, etc.).
          </p>
          <p>
            I materiali XML-AKN qui disponibili sono rilasciati con
            <a target="_blank" href="https://creativecommons.org/licenses/by/4.0/deed.it">licenza CC-BY-4.0</a>
            con preghiera di citare la fonte in questo modo nei metadati:
          </p>
          <code>
            <pre>
              &lt;http://newDataset&gt;
                  a dcatapit:Dataset, dcat:Dataset;
                  prov:wasDerivedFrom &lt;https://gitlab.com/CIRSFID/cortecostituzionale-py/tree/master/data/out/valid&gt;.

              &lt;https://gitlab.com/CIRSFID/cortecostituzionale-py/tree/master/data/out/valid&gt;
                  a dcatapit:Dataset, dcat:Dataset;
                  dct:rightsHolder &lt;https://www.indicepa.gov.it/ricerca/n-dettaglioaoo.php?cod_amm=uni_bo&cod_aoo=CIRSFID&gt;.
            </pre>
          </code>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'informazioni',
  components: {
  },
  breadcrumb: {
    label: 'Informazioni',
    parent: 'home',
  },
  mounted() {
  },
  computed: {
  },
  methods: {
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
</style>






// WEBPACK FOOTER //
// src/components/pages/Informazioni.vue